import React from "react";
import { motion } from "framer-motion";
import { LOGO_URL } from "../lib/api";

const LIFESTYLE = "https://images.unsplash.com/photo-1767897213817-8664d9b82393";

export default function About() {
  return (
    <div className="pt-16" data-testid="about-page">
      <section className="relative px-6 md:px-12 lg:px-24 py-24 md:py-32 overflow-hidden">
        <img src={LIFESTYLE} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black" />
        <motion.div initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="relative z-10 max-w-4xl">
          <p className="font-mono-alt text-xs tracking-[0.4em] text-[var(--hk-orange)] mb-6">/ ABOUT HIGH KEY</p>
          <h1 className="font-display text-6xl md:text-8xl font-bold uppercase tracking-tighter leading-[0.9]">
            Loud <span className="italic text-[var(--hk-purple-text)]">on purpose.</span>
          </h1>
          <p className="mt-8 text-gray-300 text-lg max-w-2xl">
            High Key started in a garage with one canister of purple, one orange spray cap, and a sticker machine.
            Four years later we&apos;re a licensed cannabis label pressing quarterly drops with full campaign art,
            lookbooks, and release shows.
          </p>
        </motion.div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-24 grid md:grid-cols-3 gap-10">
        {[
          { n: "01", title: "Small-batch", body: "Every strain is tested, photographed, and copywritten before it ever touches a shelf. We release when it\u2019s ready — not on schedule." },
          { n: "02", title: "Media-first", body: "Each drop comes with a lookbook, a trailer, and a release night. We treat product like an album." },
          { n: "03", title: "Clean labs", body: "Full panel lab results on every jar. Scan the QR. Know what you\u2019re burning." },
        ].map((item, i) => (
          <motion.div
            key={item.n}
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="border-l-2 border-[var(--hk-purple)] pl-6"
          >
            <span className="font-mono-alt text-xs tracking-[0.4em] text-[var(--hk-orange)]">/ {item.n}</span>
            <h3 className="font-display text-3xl uppercase tracking-tight mt-3 mb-4">{item.title}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{item.body}</p>
          </motion.div>
        ))}
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-24 bg-[var(--hk-surface)] flex flex-col md:flex-row items-center gap-12">
        <img src={LOGO_URL} alt="High Key" className="w-48 md:w-64 drop-shadow-[0_0_40px_rgba(147,51,234,0.6)]" />
        <div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter">The sticker is the seal</h2>
          <p className="mt-6 text-gray-400 max-w-2xl">
            Every High Key jar ships with a hand-pressed sticker. Peel it, stick it, post it.
            It&apos;s the whole point.
          </p>
        </div>
      </section>
    </div>
  );
}
